<template>
  <div class="flex flex-col w-full h-full min-w-full">
    <div class="flex flex-row justify-between">
      <div class="my-auto text-sm font-semibold uppercase" v-text="t('assetsList.reverseLookup')" />
      <div class="flex items-center">
        <tx-button type="text" class="text-primary-500" :text="t('general.clear')" @click="doReset" />
      </div>
    </div>
    <div class="flex-shrink mb-5 overflow-auto " style="min-width: 0;">
      <fieldset
        class="relative p-3 mb-2 mt-7 ml-2 flex flex-col "
      >
        <input ref="inputFile" type="file" accept="image/*" @change="onReverseImageChange">
      </fieldset>
    </div>
    <div class="grow">
      <img v-if="reverseImageUrl" :src="reverseImageUrl" alt="Selected image preview">
    </div>
    <div class="flex flex-row justify-between flex-shrink-0 mb-5 h-14 min-h-14">
      <tx-button type="cancel" :text="t('general.cancel')" @click="doCancel" />
      <tx-button type="confirm" :text="t('general.apply')" :disabled="!reverseImageUrl" @click="doConfirm" />
    </div>
  </div>
</template>

<script lang="ts" setup>
import { ref } from 'vue'
import { useI18n } from 'vue-i18n'
import TxButton from '@/shared/components/TxButton.vue'

const emit = defineEmits<{
  (e: 'cancel'): void
  (e: 'confirm', image: string): void
}>()
const { t } = useI18n()
const reverseImageUrl = ref<string | null>(null)
const inputFile = ref<HTMLInputElement | null>(null)

function onReverseImageChange(event: Event) {
  const target = event.target as HTMLInputElement
  if (target.files && target.files.length > 0) {
    const file = target.files[0]
    if (file && file.type.startsWith('image/')) {
      const reader = new FileReader()
      reader.onload = function () {
        const base64String = reader.result // includes "data:image/png;base64,...."
        reverseImageUrl.value = base64String as string
      }

      reader.readAsDataURL(file)
    }
    else {
      reverseImageUrl.value = null
    }
  }
  else {
    reverseImageUrl.value = null
  }
}

function doReset() {
  reverseImageUrl.value = null
  if (inputFile.value) {
    inputFile.value.src = ''
    inputFile.value.value = ''
  }
}

function doCancel() {
  emit('cancel')
}

function doConfirm() {
  emit('confirm', reverseImageUrl.value!)
}
</script>
